// Tables from the rich text editor scroll sideways on small screens
// (figure.table, see styles/richtext.css). A scroll container needs to
// be reachable by keyboard (WCAG 2.1.1), so it gets a tab stop and a
// name: the table caption, or else the heading of its section. Blocks
// with their own scroll containers set these attributes in the markup.
function labelFor(figure: HTMLElement): string {
  const caption = figure.querySelector('caption, figcaption')?.textContent?.trim();
  if (caption) {
    return caption;
  }
  return figure.closest('.th-section')?.querySelector('h2, h3')?.textContent?.trim() ?? 'Tabelle';
}

function initScrollRegions(): void {
  document.querySelectorAll<HTMLElement>('.th-richtext figure.table').forEach((figure) => {
    figure.setAttribute('tabindex', '0');
    figure.setAttribute('role', 'region');
    figure.setAttribute('aria-label', labelFor(figure));
  });
}
document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', initScrollRegions) : initScrollRegions();
